import { useCategories } from '@/entities/categories/composables/useCategories';
import type { IBreadcrumbs } from '@/shared/ui/Breadcrumbs/types';

export const useProductDetail = async () => {
  const route = useRoute();
  const { t, locale } = useI18n();
  const localePath = useLocalePath();
  const { $productsService } = useNuxtApp();
  const { subcategories, category } = useCategories();

  const getSlug = (cat: any) => {
    if (!cat) return '';
    return cat[`slug_${locale.value}`];
  };

  const { data: product } = await useAsyncData('productDetail', async () => {
    const { data } = await $productsService.getProductBySlug(String(route.params.product));
    return data || {};
  });

  const subcategory = computed(() => {
    return subcategories.value.find(sub => getSlug(sub) === route.params.subcategory);
  });

  const itemLink = (name: string, params: { category: string; subcategory?: string }) => {
    return localePath({
      name,
      params,
    });
  };

  const breadcrumbs: Ref<IBreadcrumbs[]> = computed(() => {
    const arr: IBreadcrumbs[] = [
      {
        id: 1,
        text: t('main'),
        link: localePath('/')
      },
      {
        id: 2,
        text: t('catalog'),
        link: localePath('catalog')
      },
      {
        id: 3,
        text: category.value?.name || '',
        link: itemLink('catalog-category', { category: getSlug(category.value) }),
      }
    ];

    if (subcategory.value?.name) {
      arr.push({
        id: 4,
        text: subcategory.value.name,
        link: itemLink('catalog-category-subcategory', {
          category: getSlug(category.value),
          subcategory: getSlug(subcategory.value),
        }),
      });
    }

    arr.push({
      id: arr.length + 1,
      text: product.value?.name || '',
    });

    return arr;
  });

  return {
    breadcrumbs,
    product,
  };
};
